import { handleActions } from 'redux-actions';
import { Actions, featuresLoaded } from 'actions/featuresActions';
import { FeatureVisibility } from 'shared/models';
import { Dictionary, keyBy, mapValues } from 'lodash';

export type State = Readonly<{
    visibility: Dictionary<FeatureVisibility>;
}>;

export const initialState = Object.freeze<State>({
    visibility: {},
});

export const featuresReducer = handleActions({
    [Actions.FEATURES_LOADED]: (state: State, action: ReturnType<typeof featuresLoaded>) => {
        const features = action.payload;
        return {
            ...state,
            visibility: mapValues(keyBy(features, 'id'), f => f.visibility),
        };
    },
}, initialState);
